import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #0a0c0f;
    --navy: #0f1115;
    --light-navy: #1a1d23;
    --lightest-navy: #252830;
    --navy-shadow: rgba(15, 17, 21, 0.7);
    --dark-slate: #565c66;
    --slate: #6b7280;
    --light-slate: #d1d5db;
    --lightest-slate: #e5e7eb;
    --white: #f3f4f6;
    --green: #79bac1;
    --green-tint: rgba(121, 186, 193, 0.1);
    --pink: #f57dff;
    --blue: #57cbff;

    --font-sans: 'Plus Jakarta Sans', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-hero: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
